import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useGeneralStore } from "%/stores/general-store";

export const useMyExpertServicePackageFeedStore = defineSmartFeedPiniaStore("my-expert-service-package-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    defaultFilterValues: {
      orgId: {
        "key": "org_id",
        "payload": useGeneralStore().orgId,
      },
    },
    tableFields: [
      {
        key: "name",
        label: "Name",
      },
      {
        key: "description",
        label: "Description",
      },
      {
        key: "price",
        label: "Price",
      },
      {
        key: "timestampCreated",
        label: "Created",
      },
      {
        key: "actions",
        label: "Actions",
      },
    ],
  }),
  getters: {
    feedUrl() {
      return `/expert/${useGeneralStore().orgId}/my-packages`;
    },
  },
});
